<template>
  <footer class="bg-lightPink">
    <div class="mx-auto px-4">
      <div class="w-full flex flex-col md:flex-row justify-center items-start md:items-center">

        <!-- Left Section (Logo and Social Icons) -->
        <div class="flex flex-col items-center md:items-start ">
          <img src="@/assets/images/logo.png" alt="MyUniversityOptions Logo" class="w-64">

          <div class="flex space-x-4  ml-12">
            <a href="#" class="text-purple-800 text-2xl   text-purple">
              <i class="fab fa-facebook"></i>
            </a>
            <a href="#" class="text-purple-800 text-2xl  text-purple">
              <i class="fab fa-instagram"></i>
            </a>
            <a href="#" class="text-purple-800 text-2xl  text-purple">
              <i class="fab fa-linkedin"></i>
            </a>
            <a href="#" class="text-purple-800 text-2xl text-purple">
              <i class="fas fa-envelope"></i>
            </a>
          </div>
        </div>

        <!-- Center Section (Divider) -->
        <div class="hidden md:block border-l-2 border-purple h-32 mx-10 mt-6"></div>

        <!-- Right Section (Links) -->
        <div class="grid grid-cols-2 md:grid-cols-4 gap-12 mt-8 md:mt-10 text-center md:text-left text-purple">
          <div>
            <router-link to="#" class="leading-loose block">Departments</router-link>
            <router-link to="#" class="leading-loose block">Programs</router-link>
            <router-link to="#" class="leading-loose block">A-Z Listing</router-link>
            <router-link to="#" class="leading-loose block">Diversity & Inclusion</router-link>
          </div>
          <div>
            <router-link to="#" class="leading-loose block">Facts</router-link>
            <router-link to="#" class="leading-loose block">History</router-link>
            <router-link to="#" class="leading-loose block">Employment</router-link>
            <router-link to="#" class="leading-loose block">Inclusion</router-link>
          </div>
          <div>
            <router-link to="#" class="leading-loose block">Sustainability</router-link>
            <router-link to="#" class="leading-loose block">Accessibility</router-link>
            <router-link to="#" class="leading-loose block">Accreditation</router-link>
            <router-link to="#" class="leading-loose block">Events</router-link>
          </div>
          <div>
            <router-link to="#" class="leading-loose block">Diversity</router-link>
            <router-link to="#" class="leading-loose block">Privacy</router-link>
            <router-link to="#" class="leading-loose block">Copyright</router-link>
            <router-link to="#" class="leading-loose block">Trademarks</router-link>
          </div>
        </div>


      </div>
    </div>

    <!-- Footer Bottom Section -->
    <div class="bg-purple text-center py-2 mt-7">
      <p class="text-white">
        © 2024 MyUniversityOptions. All Rights Reserved
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped>
footer {
  color: white;
  width: 100%;
}
</style>
